import React, { useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppFab from "./WhatsAppFab";
import EnquiryModal from "./EnquiryModal";
import EnquiryTab from "./EnquiryTab";
import useReveal from "../hooks/useReveal";
import { Toaster } from "./ui/toaster";

function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 120);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}

export default function Layout() {
  const { pathname } = useLocation();
  useReveal();

  return (
    <>
      <ScrollManager />
      <Navbar transparent={pathname === "/"} />
      <main>
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFab />
      <EnquiryTab />
      <EnquiryModal />
      <Toaster />
    </>
  );
}
